import React from "react";
import { FaCheckCircle } from "react-icons/fa";
import GoodCallImage from "../assets/goodcall.png";

const GoodCall = () => {
  return (
    <div className="good-call-container">

      {/* What section */}
      <div className="good-call-section">
        <h2 className="good-call-heading">What is Good Call?</h2>
        <p className="good-call-description">
          The friend everyone wishes for.
        </p>
        <p className="good-call-description">
          When the world feels heavy, it’s not advice we need—it’s someone who simply listens.
        </p>
        <p className="good-call-description">
          Good Call connects you to a real human who truly gets you. No bots. No scripts. Just care.
        </p>
        <p className="good-call-description">
          Whether it's voice, video, or chat, this is not therapy. This is empathy. Pure and simple.
        </p>

        <h3 className="good-call-subheading">What Is Good Call?</h3>
        <ul className="good-call-list">
          <li>No bots</li>
          <li>No clinical language</li>
          <li>Just one real, caring voice when it matters most</li>
        </ul>
        <p className="good-call-description">
          One call. One connection. One safe space to be yourself.
        </p>
      </div>

      {/* How section */}
      <div className="good-call-section">
        <h2 className="good-call-heading">How It Works</h2>
        <ul className="good-call-list">
          <li>
            <strong>Sign Up with Your Phone</strong>
            <p>Just your number is enough to get started—no forms, no delays.</p>
          </li>
          <li>
            <strong>Buy Your Talk Time</strong>
            <p>Choose what you need. Pay only for what you use. Simple and flexible.</p>
          </li>
          <li>
            <strong>Call and Talk Heart to Heart</strong>
            <p>Connect with a real human. No judgment. No advice. Just empathy.</p>
          </li>
          <li>
            <strong>Recharge Anytime</strong>
            <p>Top up your talk time whenever you need. Because some feelings take time to unfold.</p>
          </li>
        </ul>
      </div>

      {/* Why section */}
      <div className="good-call-section good-call-why">
        <h2 className="good-call-heading">Why Good Call?</h2>
        <div className="good-call-content">
          <div className="good-call-features">
            {[
              "Talk your heart out—no judgment, just care",
              "Someone real, who truly listens",
              "A friend in the middle of your hardest hour",
              "Anytime, anywhere. We’re here, round the clock",
              "Voice, video, or chat—whatever feels right",
              "100% private. Always safe. Always yours",
              "No bots. No scripts. Just real people who care",
              "When it feels too much—don’t carry it alone",
              "Your story matters. And so, do you",
            ].map((text, idx) => (
              <p key={idx} className="good-call-feature">
                <FaCheckCircle className="good-call-icon" /> {text}
              </p>
            ))}
          </div>
          <img
            src={GoodCallImage}
            alt="Good Call Illustration"
            className="good-call-image"
          />
        </div>
      </div>

    </div>
  );
};

export default GoodCall;
